import React from 'react';
import { useTheme } from 'styled-components';
import { useAppSelector } from '../../logic/store/Store';
import { SingleRow } from './SingleRow';
import { sortByHighestSeverity } from '../../logic/store/Insights/InsightsModels';
import { SectionHeader } from './Components/SectionHeader';

interface IMultiSalesRepViewProps
{
	onSelectSalesRep: (Id: string) => void;
}

export const MultiSalesRepView = (props: IMultiSalesRepViewProps) =>
{
	const theme = useTheme();

	const { onSelectSalesRep } = props;

	// AI Insights objects from slice
	const salesRepInsights = useAppSelector(s => s.insights.multiSalesRepAnalyses);

	// Sort the sales reps by severity
	const sortedSalesReps = React.useMemo(() =>
	{
		if (!salesRepInsights || salesRepInsights.length === 0)
		{
			return [];
		}

		return sortByHighestSeverity(salesRepInsights, s => s.Report?.Concerns || [], s => s.SalesRepName);
	}, [salesRepInsights]);

	return (
		<div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '98%', overflow: 'hidden' }}>
			<SectionHeader>
					Sales Reps
			</SectionHeader>
			<div style={{ display: 'flex', overflowY: 'auto', flexDirection: 'column', alignItems: 'center', paddingBottom: 20 }}>
				{
					sortedSalesReps?.map((salesRep) =>
					{
						return (
							<SingleRow
								key={salesRep.item.SalesRepUserId}
								Id={salesRep.item.SalesRepUserId}
								onSelect={onSelectSalesRep}
								Name={salesRep.item.SalesRepName}
								NumberOfItems={salesRep.item.SellerAnalyses?.length}
								NumberOfItemsTitle={'Sellers'}
								Severity={salesRep.highestSeverity}
								SeverityCount={salesRep.count}
							/>
						);
					})
				}
			</div>
		</div>
	);
};
